<template >
    <v-flex>
        <v-flex v-if="!hideInterfaceBeforeCheck">
            <v-progress-linear :indeterminate="true"></v-progress-linear>
        </v-flex>
        <v-flex v-if="hideInterfaceBeforeCheck">
            <v-toolbar flat class="transparent mx-auto mb-4">
                <v-toolbar-title class="headline">{{msg}}</v-toolbar-title>
            </v-toolbar>
            <v-flex xs12>
                <!--
            <div class="text-xs-center">
                <v-text-field v-model="vusername" label="Username" ></v-text-field>
                <v-text-field v-model="vpassword" label="Password" :type="'password'" ></v-text-field>
                <v-btn round color="primary" dark  v-on:click.native="logUserIn(vusername, vpassword)">Login</v-btn>
                <v-btn round color="primary" dark  v-if="true" v-on:click.native="forgot(vusername)">Forgot Password</v-btn>
                <v-btn round color="primary" dark  v-if="true" @click.stop="dialog = true">Create Account</v-btn>
                <v-btn round color="primary" dark  v-if="true"  v-on:click.native="logUserOut()">Logout</v-btn>
                <v-btn round color="primary" dark  v-if="false"  v-on:click.native="getSession()">Get Session</v-btn>
                <v-btn round color="primary" dark  v-if="false"   v-on:click.native="listUsers()">List Users</v-btn>
            </div>
            -->

                    <v-card tile class="mb-4">
                    <v-toolbar card dark color="primary">
                        <v-btn  v-if="false" icon @click.native="dialog = false" dark>
                        <v-icon>close</v-icon>
                        </v-btn>
                        <v-toolbar-title>{{appTitle}} Account Settings</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>

                        <v-flex xs10 mx-auto>
                            <div class="text-xs-center">
                                <div class="headline mt-4">Update your {{appTitle}} Account</div>
                                <div class="text-xs-left mt-4 mb-2">* All fields are required.</div>
                                <form>
                                <v-text-field
                                    v-model="vemail"
                                    label="Email" disabled ></v-text-field>
                                <v-text-field
                                    v-model="vusername"
                                    label="Username" disabled></v-text-field>
                                <v-text-field
                                    v-model="vname"
                                    label="Name" ></v-text-field>
                                <v-select
                                    label="What are your Goals?"
                                    :items="GoalsDefaults"
                                    v-model="vgoals"
                                    multiple
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                    :error-messages="errors.collect('vgoals')"
                                    data-vv-name="vgoals"
                                    v-validate="'required'"
                                ></v-select>
                                <v-select
                                    label="What do you sing?"
                                    :items="SingerTypeDefaults"
                                    v-model="vsingerType"
                                    multiple
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                    :error-messages="errors.collect('vsingerType')"
                                    data-vv-name="vsingerType"
                                    v-validate="'required'"
                                ></v-select>
                                <v-select
                                    label="Gender?"
                                    :items="GenderDefaults"
                                    v-model="vgenderType"
                                    multiple
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                :error-messages="errors.collect('vgenderType')"
                                    data-vv-name="vgenderType"
                                    v-validate="'required'"
                                ></v-select>
                                <v-select
                                    label="Age?"
                                    :items="AgeDefaults"
                                    v-model="vage"
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                :error-messages="errors.collect('vage')"
                                    data-vv-name="vage"
                                    v-validate="'required'"
                                ></v-select>
                                <v-select
                                    label="Voice Type?"
                                    :items="VoiceTypeDefaults"
                                    v-model="vvoiceType"
                                    multiple
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                    :error-messages="errors.collect('vvoiceType')"
                                    data-vv-name="vvoiceType"
                                    v-validate="'required'"
                                ></v-select>
                                <v-select
                                    label="Voice Descriptives?"
                                    :items="VoiceDescriptivesDefaults"
                                    v-model="vvoiceDescriptive"
                                    multiple
                                    chips
                                    hint=""
                                    persistent-hint
                                    required
                                    :rules="itemRules"
                                    :error-messages="errors.collect('vvoiceDescriptive')"
                                    data-vv-name="vvoiceDescriptive"
                                    v-validate="'required'"
                                ></v-select>
                               <v-checkbox
                                    label="Terms of Service"
                                    v-model="termsOfService"
                                    required
                                    hint="Do you agree to the Terms of Service?"
                                    persistent-hint
                                    :rules="itemRules"
                                    :error-messages="errors.collect('termsOfService')"
                                    data-vv-name="termsOfService"
                                    v-validate="'required'"
                                    color="primary"
                                ></v-checkbox>
                                <div class="text-xs-left mt-2 mb-2">
                                    <router-link to="/terms" >
                                        <a>{{appTitle}} Terms of Service</a>
                                    </router-link>
                                </div>
                                <div class="text-xs-left mt-2 mb-2">
                                    * This application offers recommendations for best practices with regard to voice use.
                                    The guidelines and information are for educational purposes and not intended to make medical diagnoses.
                                    Users wanting a medical diagnosis should seek the advice of a qualified physician.
                                </div>
                                <v-btn class="mb-4" round color="primary" dark  @click="updateAccount(vvoiceDescriptive, vage, vname, vgenderType, vvoiceType, vgoals, vsingerType, termsOfService)">Update Account</v-btn>
                                <v-btn round v-if="false" color="primary" dark  @click.native="dialog = false" >Back to Login</v-btn>
                                <v-alert class="mb-4" type="success" v-model="createSuccess" dismissible>{{createSuccessMessage}}</v-alert>
                                <v-alert class="mb-4" type="error" v-model="valErrors" dismissible>{{valErrorsMessage}}</v-alert>
                                </form>
                            </div>
                        </v-flex>

                    </v-card-text>

                    </v-card>
            </v-flex>
        </v-flex>
    </v-flex>
</template>

<style scoped>
.splash-flex{
    display: flex;
    justify-content: center;
    height: 80%;
    flex-flow: column;

}
.splash-logo-txt{
    color: #1a75d2;
    font-weight: 500;
}
.splash-login{ width: 60%; margin: auto;}
</style>

<script>

import LoginService from './LoginService.js'
import AppConst from './AppConst.js'

import CreateUserMutation from './mutations/CreateUserMutation'
import UpdateUserMutation from './mutations/UpdateUserMutation'
import ListUsersQuery from './queries/ListUsersQuery';
import SingleUserQuery from './queries/SingleUserQuery';
//import axios from 'axios'

var startSessionValid='';
LoginService.getSession(this, function(data){
    startSessionValid=data;
});



var appTitleLocal = AppConst.appTitle;

export default {
    $_veeValidate: {
      validator: 'new'
    },

  data () {
    return {
      vusername:localStorage.username,
      vpassword: '',
      vname: name,
      vemail: localStorage.email,
      vvoiceDescriptive: [],
      vage: [],
      vgenderType: [],
      vvoiceType: [],
      vgoals: [],
      vsingerType: [],
      valid: false,
      createMe: 'true',
      msg: 'User Profile',
      session: startSessionValid,
      dialog: false,
      dialog1: !startSessionValid,
      appTitle: appTitleLocal,
      VoiceTypeDefaults: AppConst.registerVoiceTypeDefaults,
      AgeDefaults: AppConst.registerAgeDefaults,
      GenderDefaults: AppConst.registerGenderDefaults,
      SingerTypeDefaults: AppConst.registerSingerTypeDefaults,
      GoalsDefaults: AppConst.registerGoalsDefaults,
      VoiceDescriptivesDefaults: AppConst.registerVoiceDescriptivesDefaults,
      CreateUserMutation: CreateUserMutation,
      UpdateUserMutation: UpdateUserMutation,
      ListUsersQuery: ListUsersQuery,
      forceRegister: '',
      createSuccess: false,
      createSuccessMessage: '',
      valErrors: false,
      valErrorsMessage: '',
      hideInterfaceBeforeCheck: false,
      termsOfService: false,
      itemRules: [
        v => !!v || 'All fields are required.',
      ],
      dictionary: {

        custom: {
            vvoiceDescriptive: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            vage:{
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            vgenderType: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            vvoiceType: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            vgoals: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            vsingerType: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
            termsOfService: {
                    required: () => 'This field can not be empty',
                    // custom messages
                },
          select: {
             required: 'Select field is required'
          }
        }
      }
    }
  },
  methods: {

        getSession: function(){

          //console.log(LoginService.getSession())
          LoginService.getSession(function(data){
              return data;
          }
          );
        },
        forgot: function(vusername){
            LoginService.forgotLogin(vusername)
        },
        logUserIn: function(vusername, vpassword){
            LoginService.logUserIn(vusername, vpassword)
        },
        logUserOut: function(){
            LoginService.logUserOut();

        },
        updateAccount: function(vvoiceDescriptive, vage, vname, vgenderType, vvoiceType, vgoals, vsingerType, termsOfService){
            var that=this;
            if(termsOfService==false){
                that.valErrors=true;
                that.valErrorsMessage='You must agree to the terms of service.';
                return;
            }
            this.$validator.validateAll().then((result) => {
                if (result==false) {
                    that.valErrors=true;
                    that.valErrorsMessage='Please submit all required input fields.';
                    return;
                }



            /* store these locally */
            localStorage.voiceDescriptive = vvoiceDescriptive;
            localStorage.age = vage;
            localStorage.name = vname;
            localStorage.genderType = vgenderType;
            localStorage.voiceType = vvoiceType;
            localStorage.goals = vgoals;
            localStorage.singerType = vsingerType;
            var mut='';

            if(this.createMe){
                mut=CreateUserMutation;
            }
            else{
                mut=UpdateUserMutation;
            }
            var that=this;
            console.log('Updateuser');
                that.$apollo.mutate({
                    variables: {
                        input: {
                            id: localStorage.subID,
                            username: localStorage.username,
                            email: localStorage.email,
                            goals:  localStorage.goals,
                            voicePursuit:  localStorage.singerType,
                            gender: localStorage.genderType,
                            Age:    localStorage.age,
                            voiceType: localStorage.voiceType,
                            voiceDescriptives: localStorage.voiceDescriptive,
                            name: localStorage.name
                        }
                    },
                    mutation: mut
                }).then(function(data) {
                    console.log(data);
                    //close dialog
                    //post confirmation message
                    //return to home

                    that.createSuccess=true;
                    that.createSuccessMessage='User Account Updated.';
                    if(that.createMe){
                        localStorage.checkUserRegistration=false;
                        that.$router.push('home');
                    }


                }).catch(
                    error => console.error(error)

                );
               }).catch(() => {
                // this is an actual app logic error.
                });

        },
        singleUser: function(data, callback){
            this.$apollo.query({ variables: {

                            id: localStorage.subID,

                    },query: SingleUserQuery })
            .then(function logData(data) {
                callback(data);
            }).catch(console.error);
        },
  },
  mounted(that=this){
      if(localStorage.checkUserRegistration=='true'){
          that.hideInterfaceBeforeCheck=false;
      }
      that.singleUser(localStorage.subID, function(data){

        var me=data.data.singleUser;

       if(!(me==null || me==undefined)){
            if(localStorage.checkUserRegistration=='true'){
                localStorage.checkUserRegistration=false;
                that.hideInterfaceBeforeCheck=true;
                that.$router.push('home');
            }
            that.vvoiceDescriptive=me.voiceDescriptives.split(",");
            that.vage= me.Age;
            that.vgenderType= me.gender.split(",");
            that.vvoiceType= me.voiceType.split(",");
            that.vgoals= me.goals.split(",");
            that.vsingerType= me.voicePursuit.split(",");
            that.vname=me.name;
            that.termsOfService=true;
            that.createMe=false;
            that.hideInterfaceBeforeCheck=true;
       }
       else{
            localStorage.checkUserRegistration=true;
            that.hideInterfaceBeforeCheck=true;
       }
      });

      that.$validator.localize('en', this.dictionary);
  }

}


</script>



// WEBPACK FOOTER //
// src/components/UserSettings.vue